import {
  BrowserClient,
  defaultStackParser,
  defaultIntegrations,
  makeFetchTransport,
  Hub,
} from "@sentry/browser";

export let SentryHub: Hub | undefined;

export function initMonitoring(release: string) {
  if (import.meta.env.MODE !== 'library') return

  const client = new BrowserClient({
    dsn: import.meta.env.VITE_SENTRY_DSN as string,
    release,
    transport: makeFetchTransport,
    stackParser: defaultStackParser,
    integrations: defaultIntegrations,
    denyUrls: [/https?:\/\/localhost/, /https?:\/\/127.0.0.1/]
  });

  SentryHub = new Hub(client);

  return SentryHub
}
